import { writeUsb } from "./webUsbPrinter";

// The browser build continues to use WebUSB exactly as before. Electron sends
// ESC/POS bytes through its main process to the OS-installed thermal printer.
export const isElectronRuntime = () =>
  typeof window !== "undefined" && window.desktopRuntime?.isElectron === true;

export const writeUsbForRuntime = async (bytes, options = {}) => {
  if (isElectronRuntime()) {
    options.onStatus?.("Sending to native printer...");
    if (!window.desktopPrinter?.printRaw) {
      throw new Error(
        "Native printing is unavailable in this Electron build. Please restart the desktop app."
      );
    }

    const result = await window.desktopPrinter.printRaw({
      bytes: Array.from(bytes || []),
    });
    if (!result?.success) {
      throw new Error(result?.message || "Native printer could not accept the job.");
    }
    options.onStatus?.("Print job sent to native printer.");
    return result;
  }

  return writeUsb(bytes, options);
};
